import Utils from "@/utilities/Utils";
import ApiClient from "@/utilities/ApiClient";
import { mapData } from "@/utilities/DataMapping";

export interface IResource {
    id: string;
    description: string;
    httpContentType: string;
    size: number;
    originalFilename: string;
    filename: string;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;
}

export class Resource implements IResource {

    constructor(data?: IResource|string) {
        if(typeof data === "string") {
            this.originalFilename = data;
        }
        else if (data) this.update(data);
    }

    update(data: IResource): Resource {
        mapData(data, { root: () => this });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    description: string = "";
    httpContentType: string = "";
    size: number = 0;
    originalFilename: string = "";
    filename: string = "";
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    get isNew(): boolean {
        return Utils.isEmptyId(this.id);
    }

    get hasFile(): boolean {
        console.log(`+++ get hasFile ${this.filename} | ${this.originalFilename} | `, !Utils.isEmptyOrWhitespace(this.filename));
        return !Utils.isEmptyOrWhitespace(this.filename);
    }

    get sourceUrl(): string|null {
        return this.filename
            ? ApiClient.resolveUrl(`/api/file/get?filename=${encodeURIComponent(this.filename)}&contenttype=${encodeURIComponent(this.httpContentType)}`)
            : null;
    }
}


